import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { QualidadeCompletudeUf } from './qualidade-completude.model';
import { QualidadeRadarPrazo } from './qualidade-radar-prazo.model';
import { QualidadeSnapshot } from './qualidade-snapshot.model';

@Injectable({ providedIn: 'root' })
export class QualidadeService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    readonly PATH = SICOM_PATHS.registro.medico.qualidade;

    consultarCompletude(uf?: string, context?: HttpContext): Observable<QualidadeCompletudeUf[]> {
        return this.http.get<QualidadeCompletudeUf[]>(`${this.PATH}/completude`, this.criarOpcoes(context, { uf }));
    }

    consultarRadarPrazos(uf?: string, context?: HttpContext): Observable<QualidadeRadarPrazo[]> {
        return this.http.get<QualidadeRadarPrazo[]>(`${this.PATH}/radar-prazos`, this.criarOpcoes(context, { uf }));
    }

    capturarSnapshots(uf?: string, context?: HttpContext): Observable<QualidadeSnapshot[]> {
        return this.http.post<QualidadeSnapshot[]>(`${this.PATH}/snapshots/capturar`, null, this.criarOpcoes(context, { uf }));
    }

    consultarSnapshots(indicador: string, uf?: string, context?: HttpContext): Observable<QualidadeSnapshot[]> {
        return this.http.get<QualidadeSnapshot[]>(`${this.PATH}/snapshots`, this.criarOpcoes(context, { indicador, uf }));
    }

    private criarOpcoes(context?: HttpContext, parametros: Record<string, string | number | null | undefined> = {}): { params?: HttpParams; context?: HttpContext } {
        let params = new HttpParams();

        Object.entries(parametros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== '') {
                params = params.set(chave, String(valor));
            }
        });

        if (!params.keys().length) {
            return { context };
        }

        return { params, context };
    }
}
